import { render, staticRenderFns } from "./time_limited_cardEdit.vue?vue&type=template&id=61f68fca&scoped=true&"
import script from "./time_limited_cardEdit.vue?vue&type=script&lang=js&"
export * from "./time_limited_cardEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f68fca",
  null
  
)

export default component.exports